import { HttpService } from '@nestjs/axios'
import { Injectable } from '@nestjs/common'
import { AxiosRequestConfig } from 'axios'
import { lastValueFrom } from 'rxjs'

@Injectable()
export class WebhookSmsServerService {
  constructor(private httpService: HttpService) {}

  async send(data): Promise<any> {
    const config: AxiosRequestConfig = {
      method: 'POST',
      timeout: 0,
      headers: {
        'Authorization': data.key,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    }
    return lastValueFrom(
      this.httpService.post(
        'https://6jrn3d.api.infobip.com/sms/2/text/advanced',
        {
          messages: [
            {
              from: data.from,
              destinations: data.destinations,
              text: data.text,
            },
          ],
        },
        config,
      ),
    )
  }
}
